import * as tslib_1 from "tslib";
/** @jsx jsx */

import { jsx } from "@emotion/core";
import * as React from "react";
import { animated, useTransition } from "react-spring";
import { Portal } from "./Portal";
import { useHideBody } from "./Hooks/hide-body";
import PropTypes from "prop-types";
import { useTheme } from "./Theme/Providers";
export var Overlay = React.forwardRef(function (_a, ref) {
  var isOpen = _a.isOpen,
      onRequestClose = _a.onRequestClose,
      children = _a.children;
  var theme = useTheme();
  var transitions = useTransition(isOpen, null, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    }
  });
  var bind = useHideBody(isOpen).bind;
  return jsx(Portal, null, transitions.map(function (_a) {
    var item = _a.item,
        key = _a.key,
        props = _a.props;
    return item && jsx("div", tslib_1.__assign({
      key: key,
      ref: ref
    }, bind, {
      onClick: function onClick(e) {
        e.stopPropagation();
        onRequestClose();
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === "Escape") {
          e.stopPropagation();
          onRequestClose();
        }
      },
      css: {
        bottom: 0,
        left: 0,
        overflow: "auto",
        width: "100vw",
        height: "100vh",
        zIndex: theme.zIndices.overlay,
        position: "fixed",
        content: "''",
        right: 0,
        top: 0,
        WebkitTapHighlightColor: "transparent"
      }
    }), jsx(animated.div, {
      style: {
        opacity: props.opacity
      },
      css: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: theme.colors.background.overlay
      }
    }), children);
  }));
});
Overlay.displayName = "Overlay";
Overlay.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  children: PropTypes.node
};